import React from 'react';

const Alert = function (props) {
    return (<div className={"alert alert-" + props.type}>{props.children}</div>)
}

export default Alert;